import {
	AutocompleteInput,
	BooleanInput,
	Create,
	NumberInput,
	ReferenceInput,
	required,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

export const AppCreate = () => (
	<Create redirect="show">
		<SimpleForm>
			<TextInput source="name" validate={required()} fullWidth />
			<ReferenceInput source="ownerId" reference="users">
				<AutocompleteInput
					optionText="email"
					validate={required()}
					label="Owner"
					filterToQuery={(q) => ({ email: q })}
				/>
			</ReferenceInput>
			<BooleanInput source="active" defaultValue={true} />
			<BooleanInput source="testMode" label="Test Mode" defaultValue={false} />
			<SelectInput
				source="attributionMode"
				choices={[
					{ id: "code", name: "Code" },
					{ id: "window", name: "Window" },
				]}
				defaultValue="code"
				validate={required()}
			/>
			<SelectInput
				source="attestationProvider"
				label="Attestation Provider"
				choices={[
					{ id: "none", name: "None" },
					{ id: "firebase", name: "Firebase" },
					{ id: "apple", name: "Apple" },
					{ id: "google", name: "Google" },
				]}
				defaultValue="none"
				validate={required()}
			/>
			<SelectInput
				source="iapProvider"
				label="IAP Provider"
				choices={[
					{ id: "none", name: "None" },
					{ id: "revenuecat", name: "RevenueCat" },
					{ id: "apple", name: "Apple" },
					{ id: "google", name: "Google" },
				]}
				defaultValue="none"
				validate={required()}
			/>
			<SelectArrayInput
				source="platforms"
				choices={[
					{ id: "ios", name: "iOS" },
					{ id: "android", name: "Android" },
					{ id: "any", name: "Any" },
				]}
				defaultValue={["any"]}
			/>
			<TextInput
				source="allowedCorsOrigins"
				fullWidth
				helperText="Comma-separated list of allowed CORS origins"
			/>
			<NumberInput source="minPayoutCents" label="Min Payout (cents)" />
		</SimpleForm>
	</Create>
);
